import React, { useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { KeyboardArrowUp } from "@mui/icons-material";
import {
  Card,
  CardContent,
  useTheme,
  Box,
  Button,
  List,
  ListItemButton,
  ListItemText,
  Divider,
  TextField,
  useMediaQuery,
} from "@mui/material";

const MyAccountMenu = (props) => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("lg"));
  const history = useHistory();
  const { onCancel, onSignOut } = props;
  const menuInputRef = useRef(null);

  useEffect(() => {
    menuInputRef.current.focus();
  }, []);

  return (
    <Card
      sx={{
        position: "absolute",
        right: matches ? 20 : -18,
        top: matches ? 5 : 8,
        width: 166,
        height: 280,
        border: `1px solid ${theme.palette.primary.main}`,
        zIndex: 2,
      }}
    >
      <CardContent
        sx={{ padding: 0, position: "relative", backgroundColor: "#FFF" }}
      >
        <Box>
          <TextField
            label=""
            inputRef={menuInputRef}
            variant="standard"
            onBlur={() => {
              setTimeout(() => {
                onCancel();
              }, 400);
            }}
            sx={{ zIndex: -3, position: "absolute", top: 0 }}
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            position: "relative",
            marginTop: "2px",
            padding: "10px 14px",
          }}
        >
          <Button
            variant="text"
            onClick={() => onCancel()}
            sx={{
              fontWeight: "bold",
              fontSize: "16px",
              textTransform: "none",
              minWidth: "80px",
              ":hover": {
                textDecoration: "none",
              },
            }}
            endIcon={
              <KeyboardArrowUp sx={{ color: theme.palette.secondary.main }} />
            }
          >
            My Account
          </Button>
        </Box>
        <Box>
          <Box>
            <List sx={{ width: "100%", bgcolor: "background.paper" }}>
              <Divider />
              <ListItemButton
                onClick={() => {
                  onCancel();
                  history.push("/MyAccount/MyCoupons");
                }}
              >
                <ListItemText
                  sx={{
                    paddingLeft: 1,
                    color: theme.palette.primary.main,
                    fontSize: "0.5rem",
                  }}
                  primary="My Coupons"
                  primaryTypographyProps={{
                    fontSize: "16px",
                    color: theme.palette.primary.main,
                    fontFamily: "Lato-Semibold",
                  }}
                />
              </ListItemButton>
              <Divider />
              <ListItemButton
                onClick={() => {
                  onCancel();
                  history.push("/MyAccount/Profile");
                }}
              >
                <ListItemText
                  sx={{
                    paddingLeft: 1,
                    color: theme.palette.primary.main,
                    fontSize: "0.5rem",
                  }}
                  primary="Profile"
                  primaryTypographyProps={{
                    fontSize: "16px",
                    color: theme.palette.primary.main,
                    fontFamily: "Lato-Semibold",
                  }}
                />
              </ListItemButton>
              <Divider />
              <ListItemButton
                onClick={() => {
                  onCancel();
                  history.push("/MyAccount/Settings");
                }}
              >
                <ListItemText
                  sx={{
                    paddingLeft: 1,
                    color: theme.palette.primary.main,
                    fontSize: "0.5rem",
                  }}
                  primary="Settings"
                  primaryTypographyProps={{
                    fontSize: "16px",
                    color: theme.palette.primary.main,
                    fontFamily: "Lato-Semibold",
                  }}
                />
              </ListItemButton>
              <Divider />
              <ListItemButton
                onClick={() => {
                  onSignOut();
                }}
              >
                <ListItemText
                  sx={{
                    paddingLeft: 1,
                    color: theme.palette.primary.main,
                    fontSize: "0.5rem",
                  }}
                  primary="Sign Out"
                  primaryTypographyProps={{
                    fontSize: "16px",
                    color: theme.palette.primary.main,
                    fontFamily: "Lato-Semibold",
                  }}
                />
              </ListItemButton>
            </List>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default MyAccountMenu;
